<template>
	<div class="row">
		<div class="col-sm-6">

			<input-wrapper
				id="company_email"
				label="Email Information"
			>
				<input 
					id="company_email" 
					type="email" 
					class="form-control" 
					v-model="initialData.company.email"
					:disabled="isLoading"
				>
			</input-wrapper>

			<input-wrapper
				id="company_phone_no"
				label="Phone No Information"
			>
				<input 
					id="company_phone_no" 
					type="text" 
					class="form-control" 
					v-model="initialData.company.phone_no"
					:disabled="isLoading"
				>
			</input-wrapper>

			<input-wrapper
				id="company_website"
				label="Website Information"
			>
				<input 
					id="company_website" 
					type="text" 
					class="form-control" 
					v-model="initialData.company.website"
					:disabled="isLoading"
				>
			</input-wrapper>
		</div>
		<div class="col-sm-6">
			<input-wrapper
				id="company_address"
				label="Billing Address"
			>
				<textarea 
					id="company_address" 
					rows="5" 
					class="form-control"
					v-model="initialData.company.address"
					:disabled="isLoading">
				</textarea>
			</input-wrapper>


			<input-wrapper id="bank_account_wrapper" label="Billing Account Information">
				<ckeditor 
					id="bank_account"
					class="form-control"
					v-model="initialData.settings.bank_account"
					:editor="editor"
					:config="editorConfig"
					:disabled="isLoading" />
			</input-wrapper>
			
		</div>
	</div>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import { defaultFields } from './helpers';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import editorConfig from '../../editor-config';

export default {
	components: {
		InputWrapper,
		ckeditor: CKEditor.component,
	},
	data() {
		return {
			editor: ClassicEditor,
			editorConfig,
		}
	},
	props: {
		initialData: {
			type: Object,
			default: defaultFields,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
